import React, { forwardRef, useImperativeHandle } from "react";
import { ICellRendererComp, ICellRendererParams } from "ag-grid-community";
import { IconButton } from "@mui/material";
import { EditOutlined } from "@mui/icons-material";
import { classHOC } from "components/app/ClassWrapper";

const EditableCellRenderer = forwardRef<Partial<ICellRendererComp>, ICellRendererParams>(
  (props, ref) => {
    const { api, rowIndex, column, colDef, value, node } = props;
    useImperativeHandle(ref, () => ({
      refresh: (p: any) => {
        if (p && p.value !== value) {
          p.api.flashCells({ rowNodes: [node], columns: [column] });
        }
        return false;
      },
    }));

    const onEditOpen = () => {
      api.startEditingCell({ rowIndex, colKey: column });
    };

    const editable =
      typeof colDef.editable === "boolean" ? colDef.editable : colDef.editable?.(props);

    if (node.rowPinned) return null;

    return (
      <div
        style={{
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          height: 46,
        }}
      >
        {editable ? (
          <IconButton
            size="small"
            onClick={onEditOpen}
          >
            <EditOutlined style={{ color: "#00a0d1", fontSize: "1rem" }} />
          </IconButton>
        ) : (
          <IconButton
            size="small"
            onClick={onEditOpen}
            disabled
          >
            <EditOutlined style={{ color: "transparent", fontSize: "1rem" }} />
          </IconButton>
        )}
        {value}
      </div>
    );
  }
);

export default classHOC(EditableCellRenderer);
